var render, staticRenderFns
import script from "./MCurrency.vue?vue&type=script&lang=ts&"
export * from "./MCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7852311a')) {
      api.createRecord('7852311a', component.options)
    } else {
      api.reload('7852311a', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/MCurrency.vue"
export default component.exports